import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 20",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#323338;}" }) }), /* @__PURE__ */ _jsx("path", {
		id: "Path_7568",
		"data-name": "Path 7568",
		className: "cls-1",
		d: "M13,11H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V12A1,1,0,0,0,13,11ZM13,1V2H5V1A1,1,0,0,0,3,1V2H2A2,2,0,0,0,0,4H0V18a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H15V1a1,1,0,0,0-2,0Zm2,17H3a1,1,0,0,1-1-1V7H16V17A1,1,0,0,1,15,18Z"
	})]
});
export { SvgCalendar as ReactComponent };
